module.exports = __webpack_public_path__ + "static/media/Meowstic_gaussian2.8bdd8585.png";